export const INPUT_REPLACE_TYPE = 'inputReplaceType';
export const ANCHOR_TYPE = 'anchorType';
export const CHOICE_SHOW_IF_TYPE = 'choiceShowIfType';
